var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg_main"},[_c('div',{staticClass:"primary"}),_c('v-container',[(_vm.currentCartStep === 1)?_c('Cart1',{attrs:{"next-step":_vm.nextStep}}):_vm._e(),(_vm.currentCartStep === 2)?_c('Cart2',{attrs:{"next-step":_vm.nextStep}}):_vm._e(),(_vm.currentCartStep === 3)?_c('Cart3'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }